<template>
    <div class="container" v-loading="tableing">
        <div class="header">
            <el-button class="exit" size="mini" @click="exit()"> 退出 </el-button>
        </div>
        <div class="main">
            <div class="main-clone">
                <div class="detection">
                    <div class="info-title">本场考试需要打开优巡APP, 优巡EXE端进行监考</div>
                    <div class="info-road">
                        <div class="info-road-1">
                            <img src="../../../static/images/join-yx1.png" alt="" srcset="">
                            <p>打开优巡APP、优巡EXE</p>
                        </div>
                        <div class="info-road-2"></div>
                        <div class="info-road-3">
                            <img src="../../../static/images/join-yx2.png" alt="" srcset="">
                            <p>使用下面提供的准考证号与考试ID号登录优巡监控端</p>
                        </div>
                        <div class="info-road-4"></div>
                        <div class="info-road-5">
                            <img src="../../../static/images/join-yx3.png" alt="" srcset="">
                            <p>请使用电脑登录选择主机位，手机端选择副机位</p>
                        </div>
                    </div>
                    <div class="bodyBoxCenter">
                        <div class="info-app">
                            <p class="zhu-ji">主机位登录状态</p>
                            <p class="fu-ji">副机位登录状态</p>
                            <el-button class="exesy" :type="exeLogin? 'success':'info'" :icon="exeLogin? 'el-icon-check':'el-icon-close'" size="mini" style="cursor: auto;">{{exeLogin? '已登录':'未登录'}}</el-button>
                            <el-button class="appsy" :type="appLogin? 'success':'info'" :icon="appLogin? 'el-icon-check':'el-icon-close'" size="mini" style="cursor: auto;">{{appLogin? '已登录':'未登录'}}</el-button>
                        </div>
                        <div class="info-exe">
                            <span>准考证号：<b style="color:red">{{$route.query.ticketNum}}</b></span>
                            <span>考试ID号：<b style="color:red">{{$route.query.youXunExamNum}}</b></span>
                        </div>
                        <div class="waSkip-c-qr" ref="qrCodeUrl"></div>
                        <div class="info-refresh">
                            <el-button class="updateAxios" size="mini" @click="reloadOnline" :style="{background:(timeOut<10? '#8ba1c1':'')}"> {{timeOut<10? `( ${timeOut} )`:'刷新'}} </el-button>
                            <p>登陆优巡主副机位后点击刷新按钮刷新状态，状态更新为已登陆时点击下一步进入考试页面</p>
                        </div>
                    </div>
                </div>
                
                <div class="goExamBox">
                    <el-button class="upSub" @click="lastQuestion()"> 下一步 </el-button>
                </div>
            </div>
        </div>

        <el-dialog
            :class="['humanInspection',notGoing? 'maxW':'']"
            title="设备检测情况"
            :visible.sync="equipmentDialog"
            :show-close="false"
            width="60%"
            center>
            <span class="human-ing">
                <b v-show="notGoing">本次考试基于校方要求必须登录优巡一端监控才可进行考试，系统检测您当前双端优巡监控均未登录，请完成登录后点击下一步开始考试，如已登录优巡监控但系统显示为未登录状态可点击人工客服按钮寻求帮助</b>
                <b v-show="!notGoing"> {{`当前检测到优巡的${appLogin? '':'副机位'}${!appLogin&&!exeLogin? '和':''}${exeLogin? '':'主机位'}未登录，是否开始进入考试？`}} </b>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" class="sucRecard" @click="equipmentDialog = false"> {{!notGoing? '登录优巡':'返 回'}} </el-button>
                <el-button type="success" class="sucRecard" @click="lastMandatory()" v-if="!notGoing"> 确 定 </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import recording from '../../lib/recording'
import os from '../../lib/oss'
import { loginStatus,getDateNow } from '../../lib/youxunAPI';
import util from '../../lib/util'
    export default {
        name:"youXunCheck",
        data() {
            return {
                equipmentDialog:false,
                tableing:false,
                appLogin:false,
                exeLogin:false,
                notGoing:true,
                timeOut:10,
                timers:'',
            }
        },
        components:{},
        watch: {},
        computed:{},
        created(){},
        beforeDestroy() {
            clearInterval(this.timers)
        },
        mounted(){
            this.$nextTick(()=>{
                this.addUdeskCn()
                this.getLoginStatus()
                this.creatQrCode()
            })
        },
        methods:{
            reloadOnline(){
                let that = this
                if(that.timeOut<10) {
                    that.$message.info('点击频率过快，请稍后再试！');
                    return
                }
                that.getLoginStatus()
                that.timeOut -= 1
                that.timers = setInterval(() => {
                    that.timeOut--;
                    if(that.timeOut<=0){
                        clearInterval(that.timers)
                        that.timeOut = 10
                    }
                }, 1000);
            },
            addUdeskCn(){
                (function(a,h,c,b,f,g){a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})
                (window,document,"script","https://assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");
                ud({
                    "code": "2f0k97h2",
                    "link": "https://ata.s2.udesk.cn/im_client_nocdn/?web_plugin_id=61482",
                    "onlineText": "客服",
                    "offlineText": "留言",
                    "pos_flag": "hrm",
                });
                this.$nextTick(()=>{
                    let kFu = document.getElementById('udesk_container')
                    if(kFu)
                    kFu.style.display = "inherit"
                })
            },
            getLoginStatus(){
                let that = this
                loginStatus(
                    that.$route.query.youXunExamNum,
                    that.$route.query.ticketNum,
                    (response)=>{
                        if(!response.data||!response.data.data) return
                        that.appLogin = response.data.data.second,
                        that.exeLogin = response.data.data.first
                    }
                )
            },
            lastQuestion(){
                let that = this
                if(!that.appLogin&&!that.exeLogin){
                    let kaiKao;
                    getDateNow(function(response){
                        if(response.data&&response.data.code == 0){
                            if(that.$route.query.examStartDate<=response.data.data.sysTime){
                                if(that.$route.query.examEndDate<=response.data.data.sysTime){
                                    kaiKao = false;
                                }else{
                                    kaiKao = true;
                                }
                            }else{
                                kaiKao = false;
                            }
                        }else{
                            kaiKao = that.timeToCompare()
                        }
                        if(kaiKao){//已开考
                            that.getCheckSkip()
                        }else{
                            that.equipmentDialog = true
                            that.notGoing = true
                        }
                    })
                }else if(that.appLogin&&that.exeLogin){
                    that.lastGo()
                }else{
                    that.equipmentDialog = true
                    that.notGoing = false
                }   
            },
            lastMandatory(){
                this.lastGo()
            },
            lastGo(){
                let href_ = window.location.href.split('#/')[1]
                let lv = href_.indexOf('?')!=-1? href_.split('?')[0]:''
                let menuListArr = this.$route.query.menuList.split(',')
                let menuListLoc = menuListArr.indexOf(String(util.menuListGet().indexOf(lv)))
                this.$router.push({
                    path: `/${util.menuListGet()[menuListArr[menuListLoc+1]]}`,
                    query: {
                        bId:this.$route.query.bId,
                        paperName:this.$route.query.paperName,
                        userSignId:this.$route.query.userSignId,
                        ticketNum:this.$route.query.ticketNum,
                        idName:this.$route.query.idName,
                        idCardNo:this.$route.query.idCardNo,
                        youXunExamNum:this.$route.query.youXunExamNum,
                        examStartDate:this.$route.query.examStartDate,
                        examEndDate:this.$route.query.examEndDate,
                        examStatus:this.$route.query.examStatus,
                        examStartDateVal:this.$route.query.examStartDateVal,
                        examEndDateVal:this.$route.query.examEndDateVal,
                        examMin:this.$route.query.examMin,
                        personNum:this.$route.query.personNum,
                        reviewType:this.$route.query.reviewType,
                        menuList:this.$route.query.menuList,
                    }
                }) 
            },
            exit(){
                this.$confirm('请问是否退出当前考试？','确认信息',{
                    distinguishCancelAndClose:true,
                    confirmButtonText:'是',
                    cancelButtonText:'否',
                })
                .then(()=>{
                    if(sessionStorage.getItem('orgId')){//测评
                        this.$router.push({
                            path: `/${sessionStorage.getItem('orgId')}/examList`,
                        })
                    }else{
                        this.$router.push({
                            path: '/myExamList'
                        })
                    }
                })
                .catch((action)=>{})
            },
            getCheckSkip(){
                let that = this
                that.$axios.post('/paper/userSign/checkSkip',{
                    userSignId:that.$route.query.userSignId,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    let v = res.data;
                    if (v.code == 0) {
                        //true 是跳过验证  false=需要验证优巡登录
                        if(v.data.flag){
                            this.lastGo()
                        }else{
                            this.equipmentDialog = true
                            this.notGoing = true
                        }
                    }
                })
            },
            creatQrCode() {
                let json = {
                    "examNum": this.$route.query.youXunExamNum,
                    "personNum": this.$route.query.ticketNum,
                }
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: JSON.stringify(json), // 需要转换为二维码的内容
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                })
            },
            // 查看是否到考试时间
            timeToCompare(){
                let that = this
                let poorTime = window.localStorage.getItem('poorVal')
                let timestamp2 = Date.parse(new Date());
                if(Number(poorTime)>=0){timestamp2 = Number(timestamp2) + Number(poorTime)}
                else{timestamp2 = Number(timestamp2) - Number(Math.abs(poorTime))}
                if(that.$route.query.examStartDate<=timestamp2){
                    if(that.$route.query.examEndDate<=timestamp2){
                        //考试已结束
                        return false;
                    }else{
                        return true;
                    }
                }else{
                    //考试暂未开始
                    return false;
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        border-bottom: 1px solid #EDEEED;
        .exit{
            background-color: #31C4FE;
            border: none;
            font-size: 15px;
            width: 74px;
            height: 32px;
            color: #fff;
            position: absolute;
            top: 15px;
            right: 3%;
            img{
                height: 10px;
            }
        }
        .updateAxios{
            background-color: rgb(0, 75, 180);
            border: none;
            font-size: 15px;
            height: 32px;
            line-height: 16px;
            color: #fff;
            position: absolute;
            top: 15px;
            left: 3%;
        }
    }
    .main{
        position: absolute;
        top: 75px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        .main-clone{
            height:100%;
            width: 100%;
            position: relative;
            .detection{
                position: absolute;
                left: 5%;
                top: 6%;
                width: 90%;
                height: 72%;
                .info-title{
                    font-size: 2.3vh;
                    font-weight: bold;
                    height: 15%;
                    margin: auto;
                    display: flex;
                    justify-content: center;
                    align-content: center;
                }
                .info-road{
                    height: 35%;
                    width: 100%;
                    .info-road-1{
                        float: left;
                        width: 28%;
                        height: 100%;
                        background-image: url('../../../static/images/join-yx4.png');
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        position: relative;
                        img{
                            position: absolute;
                            top: 20%;
                            left: 29%;
                            height: 55%;
                        }
                        p{
                            position: absolute;
                            top: 75%;
                            left: 0%;
                            right: 0%;
                            font-size: 15px;
                            font-weight: bold;
                        }
                    }
                    .info-road-2{
                        float: left;
                        width: 8%;
                        height: 100%;
                        background-image: url('../../../static/images/join-yx7.png');
                        background-size: 60%;
                        background-repeat: no-repeat;
                        background-position: 50% 50%;
                    }
                    .info-road-3{
                        float: left;
                        width: 28%;
                        height: 100%;
                        background-image: url('../../../static/images/join-yx5.png');
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        position: relative;
                        img{
                            position: absolute;
                            top: 21%;
                            left: 29%;
                            height: 50%;
                        }
                        p{
                            position: absolute;
                            top: 75%;
                            left: 0%;
                            right: 0%;
                            font-size: 15px;
                            font-weight: bold;
                            box-sizing: border-box;
                            padding: 0 5%;
                        }
                    }
                    .info-road-4{
                        float: left;
                        width: 8%;
                        height: 100%;
                        background-image: url('../../../static/images/join-yx7.png');
                        background-size: 60%;
                        background-repeat: no-repeat;
                        background-position: 50% 50%;
                    }
                    .info-road-5{
                        float: left;
                        width: 28%;
                        height: 100%;
                        background-image: url('../../../static/images/join-yx6.png');
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        position: relative;
                        img{
                            position: absolute;
                            top: 21%;
                            left: 29%;
                            height: 50%;
                        }
                        p{
                            position: absolute;
                            top: 75%;
                            left: 0%;
                            right: 0%;
                            font-size: 15px;
                            font-weight: bold;
                            box-sizing: border-box;
                            padding: 0 5%;
                        }
                    }
                }
                .bodyBoxCenter{
                    position: absolute;
                    top: 50%;
                    bottom: 0%;
                    width: 100%;
                    .info-app{
                        position: absolute;
                        left: 0;
                        bottom: 35%;
                        width: 45%;
                        height: 34%;
                        font-size: 18.5px;
                        font-weight: bold;
                        border-right: 1px solid #B2B2B2;
                        .zhu-ji{
                            position: absolute;
                            left: 20%;
                            top: 0px;
                        }
                        .fu-ji{
                            position: absolute;
                            left: 20%;
                            bottom: 0%;
                        }
                        .exesy{
                            position: absolute;
                            left: 61%;
                            top: 0%;
                        }
                        .appsy{
                            display: inline-block;
                            margin: 0 auto;
                            position: absolute;
                            left: 61%;
                            bottom: 0%;
                        }
                    }
                    .info-exe{
                        position: absolute;
                        left: 45%;
                        bottom: 35%;
                        width: 35%;
                        height: 34%;
                        margin-right: -1px;
                        font-size: 18.5px;
                        font-weight: bold;
                        span:nth-child(1){
                            position: absolute;
                            left: 20%;
                            top: 0;
                            color: red;
                        }
                        span:nth-child(2){
                            position: absolute;
                            left: 20%;
                            bottom: 0%;
                            color: red;
                        }
                    }
                    .waSkip-c-qr{
                        position: absolute;
                        right: 0;
                        bottom: 27%;
                        width: 20%;
                        height: 50%;
                    }
                    .info-refresh{
                        position: absolute;
                        left: 0;
                        top: 65%;
                        bottom: 0%;
                        width: 100%;
                        .updateAxios{
                            background-color: #6AAEF8;
                            border: none;
                            font-size: 15px;
                            width: 74px;
                            height: 30px;
                            line-height: 16px;
                            color: #fff;
                            position: absolute;
                            top: 10px;
                            left: 10%;
                        }
                        p{
                            position: absolute;
                            top: 50px;
                            left: 0;
                            right: 0;
                            text-align: center;
                        }
                    }
                }
            }
            .goExamBox{
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 20%;
                width: 100%;
                // position: relative;
                .upSub{
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    height: 45px;
                    width: 35%;
                    background: rgb(0, 75, 180);
                    color: #FFF;
                    border-radius: 3px;
                    font-size: 18px;
                }
            }
        }
    }
</style>
<style>
    .humanInspection .el-dialog{
        width: 400px !important;
        height: 300px;
    }
    .humanInspection.maxW .el-dialog{
        width: 565px !important;
        height: 330px;
    }
    .humanInspection.maxW .el-dialog__body{
        height: 55%;
        text-indent:2.5em;
        line-height: 32px;
    }
    .humanInspection .el-dialog__body{
        height: 49%;
        padding: 10px 50px !important;
        box-sizing: border-box;
    }
    .humanInspection .el-dialog__body .human-ing{
        height: 100%;
        width: 100%;
        font-size: 19px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .humanInspection .el-dialog__footer .sucRecard{
        color: #fff;
        padding: 9px !important;
        width: 150px;
    }
    .humanInspection .el-dialog .el-dialog__header{
        background: #1D4BB0;
    }
    .detection .waSkip-c-qr canvas,
    .detection .waSkip-c-qr img{
        max-width: 100%;
        max-height: 100%;
        background-color: #fff;
        box-sizing: border-box;
        padding: 6px;
        border: 3px solid #000;
        overflow: hidden;
    }
</style>


// WEBPACK FOOTER //
// src/pages/myExamList/youXunCheck.vue